import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LoadingService {

    private isLoading: ReplaySubject<boolean> = new ReplaySubject(1);
    public isLoading$: Observable<boolean> = this.isLoading.asObservable();

    constructor() {
    }

    public start() {
        this.isLoading.next(true);
    }

    public stop() {
        this.isLoading.next(false);
    }
}
